import { LinkType, FinishType } from '@nerdwallet/react-apply-now';

export default ({ ctaCopy }) => ({
  defaultSortKey: 'currentOffers',
  className: 'currentOffers',
  reviewTarget: '_blank',
  customToggleText: {
    show: 'View Details',
  },
  productNameKey: 'product.institution.details.display_name.value',
  trackingFieldName: 'cdsAccounts',
  columns: [
    {
      title: 'Bank',
      className: 'cds',
      sort: {
        sortable: false,
        key: 'product.institution.details.nw_rating.value',
        order: 'desc',
      },
      content: [
        {
          type: 'image',
          config: {
            data_keys: ['product.institution.details.logo_url.value'],
            className: 'clearfix product-image-small',
            provider_key: 'product.institution.details.display_name.value',
            provider_id: 'id',
            product_topic: 'Banking',
            link_type: LinkType.institutionImage,
            finish_type: FinishType.externalApplicationReferral,
            link_data_key: 'derived_details.apply_link.value',
          },
        },
        {
          type: 'custom',
          component: 'ReviewAnnotation',
          config: {
            review_path: 'product.institution.details.nw_review_url.value',
          },
        },
        {
          type: 'stars',
          value: 'product.institution.details.nw_rating.value',
          config: {
            color: 'green',
          },
        },
      ],
    },
    {
      title: 'Terms',
      className: 'desktop-only',
      sort: {
        sortable: false,
        key: 'monthlyFee',
      },
      content: [
        {
          type: 'custom',
          component: 'MonthsInYears',
        },
        {
          type: 'custom',
          component: 'APYAnnotation',
        },
      ],
    },
    {
      title: 'APY',
      className: 'highlight-column',
      sort: {
        sortable: false,
        key: 'APY',
      },
      content: [
        {
          type: 'label',
          config: {
            text: 'APY',
            className: 'column-header mobile',
          },
        },
        {
          type: 'label',
          config: {
            data_keys: ['details.apy.value'],
            format: 'percentage',
            className: 'product-value',
            help: {
              data_keys: ['details.apy_annotation.value'],
            },
          },
        },
      ],
    },
    {
      title: 'CTA',
      className: 'cta-column',
      sort: {
        sortable: false,
        key: 'total',
      },
      content: [
        {
          type: 'label',
        },
        {
          type: 'apply',
          config: {
            disableAnnotation: true,
            provider_key: 'product.institution.details.display_name.value',
            link_type: LinkType.applyNowButton,
            finish_type: FinishType.externalApplicationReferral,
            provider_id: 'id',
            product_topic: 'generic',
            link_data_key: 'derived_details.apply_link.value',
            ctype: 'Offer',
            buttonText: ctaCopy,
            show_icon: false,
          },
        },
        {
          type: 'custom',
          component: 'CTAAnnotation',
        },
      ],
    },
  ],
});
